
<div class="container mt-3 mb-3" >

    <app-mat-spinner-overlay [overlay]="true" *ngIf="loading"></app-mat-spinner-overlay>


  <mat-accordion *ngIf="filterForm">
    <mat-expansion-panel expanded="false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Filtrar Usuários
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div [formGroup]="filterForm">
        <div class="row mt-2">

          <div class="col">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Nome</mat-label>
              <input matInput formControlName="dscNome" />
            </mat-form-field>
          </div>

          <div class="col">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Login</mat-label>
              <input matInput formControlName="dscLogin" />
            </mat-form-field>
          </div>

          <div class="col">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Email</mat-label>
              <input matInput formControlName="dscEmail" />
            </mat-form-field>
          </div>

          <div class="col">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Perfil</mat-label>
              <mat-select formControlName="perfil">
                <mat-option value="" disabled>Todos</mat-option>
                <mat-option *ngFor="let perfil of perfis"
                  [value]="perfil.codPerfil">{{perfil.dscPerfil}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-9 d-flex gap-2 btns-busca">
            <button mat-flat-button color="accent" type="button" (click)="applyFilter()">
              Consultar
              <mat-icon>search</mat-icon>
            </button>
            <button matButton="outlined" mat-flat-button type="button"
              (click)="filterForm.reset(); applyFilter();">Limpar Filtro
              <mat-icon>delete</mat-icon></button>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <div class="row mt-2 mb-2">
    <div class="col d-flex justify-content-end align-items-center gap-2">
      <button mat-flat-button color="accent" matTooltip="Criar novo usuario" matTooltipPosition="right"
        aria-label="Criar novo usuário" type="button" (click)="criarNovoUsuario()">
        <mat-icon>add</mat-icon>
        Criar novo usuário
      </button>

      <button mat-flat-button type="button" (click)="exportToExcel()">
        <mat-icon>description</mat-icon>
        <span> Exportar Excel</span>
      </button>
    </div>
  </div>

  <table mat-table [dataSource]="dataSource" matSort class="w-100">

    <ng-container matColumnDef="dscNome">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
      <td mat-cell *matCellDef="let usuario">{{usuario.dscNome}}</td>
    </ng-container>

    <ng-container matColumnDef="dscLogin">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Login</th>
      <td mat-cell *matCellDef="let usuario">{{usuario.dscLogin}}</td>
    </ng-container>

    <ng-container matColumnDef="dscEmail">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
      <td mat-cell *matCellDef="let usuario">{{usuario.dscEmail}}</td>
    </ng-container>

    <ng-container matColumnDef="numFone">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Telefone</th>
      <td mat-cell *matCellDef="let usuario">{{usuario.numDddFone ? (usuario.numDddFone): ''}} {{usuario.numFone}}</td>
    </ng-container>



    <ng-container matColumnDef="perfil">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Perfil</th>
      <td mat-cell *matCellDef="let usuario">{{usuario.descPerfil}}</td>
    </ng-container>

    <!-- Ações Column -->
    <ng-container matColumnDef="acoes">
      <th mat-header-cell *matHeaderCellDef> Ações </th>
      <td mat-cell *matCellDef="let usuario">

        <button mat-icon-button>
          <mat-icon matTooltip="Editar Usuario" matTooltipPosition="left" aria-label="Editar Usuario"
            aria-hidden="false" (click)="editarUsuario(usuario)">edit</mat-icon>
        </button>

        <button mat-icon-button>
          <mat-icon matTooltip="Excluir Usuario" matTooltipPosition="right" aria-label="Excluir Usuario"
            aria-hidden="false" (click)="excluirUsuario(usuario)">delete</mat-icon>
        </button>

      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['dscNome','dscLogin','dscEmail', 'numFone','perfil', 'acoes']">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['dscNome','dscLogin','dscEmail', 'numFone','perfil', 'acoes'];">
    </tr>
  </table>

  <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>

</div>
